module.exports = __webpack_public_path__ + "media/music/jazzy_bass_1-ba4bdc73.mp3";